import React from 'react';
const IconCommentConvo = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M17 2H1V15H7V13H3V4H15V13H10.53L7 17.21V20H12.53L14.21 22H16.82L13.47 18H9L11.47 15H17V9H21V18H17V20H23V7H17V2Z" fill="#2D2E2E"/>
</svg>
);
};
export default IconCommentConvo;